import validate from "/usr/src/app/content/n3-treatments-1a26c95d-19ab-452f-a1cb-ce95e92130cf/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-1a26c95d-19ab-452f-a1cb-ce95e92130cf/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}